// The ms-agents API can return a coach's employee_id in place of their real
// user_id on `participant.user_id` / `message.sender_id` (a known backend
// data issue — see the Flex Comms integration guide §3.3 and §12.1). Both
// endpoints also return a `resolved_user_id`, which is always the normalized
// real user_id. Any identity comparison or cache lookup must prefer it.

/** Normalized identity for a room participant record. */
export const participantId = (participant) =>
  participant?.resolved_user_id || participant?.user_id;

/** Normalized identity for a message's sender. */
export const senderId = (message) =>
  message?.resolved_user_id || message?.sender_id;

/**
 * Did the viewer send this message?
 *
 * Because either id form can reach us on `sender_id` — and the viewer id we
 * hold is FlexBoard's `empId`, which may itself be either form — a match on
 * EITHER field counts. Comparing only the normalized id (or only the raw one)
 * silently misses half the time, which is how a coach's own send used to
 * reach the unread/chime pipeline.
 *
 * @param {Object|null|undefined} message
 * @param {string|number|null|undefined} viewerUserId
 * @returns {boolean}
 */
export const isOwnSender = (message, viewerUserId) => {
  if (!message || viewerUserId == null) {
    return false;
  }
  const viewer = String(viewerUserId);
  return (
    (message.resolved_user_id != null &&
      String(message.resolved_user_id) === viewer) ||
    (message.sender_id != null && String(message.sender_id) === viewer)
  );
};
